var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collapse__item", class: { active: !_vm.isCollapsed } },
    [
      _c(
        "div",
        {
          ref: "title",
          staticClass: "collapse__title",
          on: { click: _vm.onCollapse }
        },
        [
          _c("h2", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c(
            "div",
            { class: [_vm.isCollapsed ? "" : "active", "collapse__item-ico"] },
            [
              _c(
                "svg",
                {
                  attrs: {
                    "enable-background": "new 0 0 14 9",
                    width: "14px",
                    height: "9px",
                    viewBox: "0 0 14 9",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "clip-rule": "evenodd",
                      d: "m.3 1.4 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7z",
                      fill: "currentColor",
                      "fill-rule": "evenodd"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        ref: "contentRef",
        class: [
          { collapse__content: true },
          { "collapse__content-active": !_vm.isCollapsed }
        ],
        style: { height: _vm.height },
        domProps: { innerHTML: _vm._s(_vm.content) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }